export default "__VITE_ASSET__Cy58RWba__"